'use client';

import styled from '@emotion/styled';

import { overflowHyphens, shouldForwardProp } from '@hrworks/design-system/utilities';

import { mq } from '../../util/mediaQueries';
import { Image as _Image } from '../Image/Image';

const horizontalMap: Record<string, string> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

const verticalMap: Record<string, string> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

// justifyContent positioniert nur die Titel-Box; bricht der Titel um, brauchen die Zeilen
// darin dieselbe Ausrichtung, sonst stehen sie linksbündig in einer zentrierten Box.
const textAlignMap: Record<string, 'left' | 'center' | 'right'> = {
  left: 'left',
  center: 'center',
  right: 'right',
};

const Container = styled('div', {
  shouldForwardProp,
})<{ $hasTitle?: boolean }>(({ $hasTitle }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // With a title, reserve enough height so the text does not scroll
  // immediately when the image is tiny or fails to load.
  minHeight: $hasTitle ? 200 : 70,
}));

const Image = styled(_Image)({
  width: '100%',
});

const Content = styled.div(({ theme }) => {
  const horizontal = theme.stellenportal?.titleStyle?.position?.horizontal || 'center';

  return {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: verticalMap[theme.stellenportal?.titleStyle?.position?.vertical || 'center'] || 'center',
    justifyContent: horizontalMap[horizontal] || 'center',
    textAlign: textAlignMap[horizontal] || 'center',
    padding: theme.eclipseTier1.spacing['16px'],
  };
});

const Title = styled.h1(({ theme }) => [
  overflowHyphens,
  {
    ...theme.eclipseTier2Typography.title,
    backgroundColor: theme.stellenportal?.titleStyle?.backgroundColor || theme.eclipseTier2Color.surface.base,
    color: theme.stellenportal?.titleStyle?.color || theme.eclipseTier2Color.text.default,
    margin: 0,
    padding: theme.eclipseTier1.spacing['16px'],
    overflow: 'auto',
    maxHeight: '100%',
    [mq['<=xs']]: {
      ...theme.eclipseTier2Typography.headingMd,
      padding: theme.eclipseTier1.spacing['8px'],
    },
  },
]);

export const S = {
  Container,
  Image,
  Content,
  Title,
} as const;
